import styled from 'styled-components'

const ZalacznikiStyle = styled.div`
  width: 100%;
  
  .fileContainer {
    width: 140px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.palette.primary.main};
    border: 1px solid ${props => props.theme.palette.primary.main};
    border-radius: 4px;
  }

  .attachment-header {
    font-family: 'Ubuntu-Light';
    font-size: 24px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    color: ${props => props.theme.black87};

    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 12px 8px 12px;
  }

  .placeholder {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .zalacznikiContainer {
    display: flex;
    justify-content: flex-end;
  }

  .fileContainer {
    input {
      display: block;
      position: absolute;
      opacity: 0;
    }
  }

  h1 {
    color: ${props => props.theme.black60};
    margin: 8px;
    font-size: 36px;
    font-weight: 300;
  }

  .listPlaceholder {
    margin-top: 130px;
    width: 65%;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .listLabel {
    width: 100%;
    height: 36px;
    display: grid;
    grid-template-columns: 554px 1fr;
    grid-column-gap: 16px;
    padding-left: 24px;
    align-items: center;
  }

  ul {
    width: 100%;
    padding: 0;
  }

  .li {
    margin-left: 32px;
  }

  .attachment {
    display: grid;
    grid-template-columns: 554px 1fr;
    grid-column-gap: 16px;
    align-items: center;
  }

  .fileInfo {
    display: flex;
    align-items: center;
  }

  .name {
    margin-left: 8px;
    white-space: nowrap;
    width: 288px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .badFileName {
    display: flex;
    margin-left: 8px;
    margin-top: -16px;
    color: ${props => props.theme.error};
    };
  }

  .container {
    width: 100%;
    padding: 0 12px;
  }

  .add-button{
    width: 222px;
    margin-top: 4px;
    margin-left: 72px;
  }
`

export default ZalacznikiStyle
